export default "__VITE_ASSET__Cs8BoMOa__"